import React, { useEffect } from 'react';
import './Login.scss';

/**
 *
 * @param elementChildren
 * @returns {JSX.Element}
 * @constructor
 */
const Login = ({ elementChildren }) => {
  let loginMainScreen, resetPasswordScreen, recoverForm, recoverSubmit, recoverSubmitSuccess;

  useEffect(() => {
    const toggleTrigger = document.querySelectorAll('.c-login__forgot');
    const hash = window.location.hash;
    loginMainScreen = document.getElementById('loginMainScreen');
    resetPasswordScreen = document.getElementById('resetPasswordScreen');
    recoverSubmitSuccess = document.getElementById('recoverSubmitSuccess');

    // Show recover form after successful password reset submission or if URL contains '#recover'
    if (hash === '#recover' || recoverSubmitSuccess) {
      togglePasswordForm();
    }

    toggleTrigger.forEach((trigger) => {
      trigger.addEventListener('click', showHidePasswordForm);
    });
  }, []);

  const showHidePasswordForm = (e) => {
    e.preventDefault();
    togglePasswordForm();
  };

  const togglePasswordForm = () => {
    loginMainScreen.classList.toggle('hidden');
    resetPasswordScreen.classList.toggle('hidden');
  };

  return (
    <section className="c-login background-color-gray">
      <div className="c-login__inner" dangerouslySetInnerHTML={{ __html: elementChildren }}></div>
    </section>
  );
};

export default Login;
